import { Directive, inject } from '@angular/core';
import { ShellStore } from '@partners/state';
import { tap } from 'rxjs';

@Directive({
  selector: '[progressTracker]',
  standalone: true
})
export class ProgressTrackerDirective {
  private _shellStore = inject(ShellStore);

  constructor() {
    this._shellStore.currentStage$
      .pipe(
        tap((stage) => {
          // console.log(`current stage`, stage);
        })
      )
      .subscribe();
  }
}
